import React from "react";

const TriggerPauseIcon = ({ size = 18, style }) => (<svg width={size} height={size} style={style} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5 2.25H11.25C10.8358 2.25 10.5 2.58579 10.5 3V15C10.5 15.4142 10.8358 15.75 11.25 15.75H13.5C13.9142 15.75 14.25 15.4142 14.25 15V3C14.25 2.58579 13.9142 2.25 13.5 2.25Z" stroke="#69687A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M6.75 2.25H4.5C4.08579 2.25 3.75 2.58579 3.75 3V15C3.75 15.4142 4.08579 15.75 4.5 15.75H6.75C7.16421 15.75 7.5 15.4142 7.5 15V3C7.5 2.58579 7.16421 2.25 6.75 2.25Z" stroke="#69687A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>
);

export default TriggerPauseIcon;

